import React from 'react';
import { ListItem } from '@one-thd/sui-atomic-components';
import proptypes from 'prop-types';
const { node, string } = proptypes;
import classNames from 'classnames';

const SalientListItem = ({ children = null, className = null, point = null }) => {
  const content = point || children;
  const classes = classNames(className, '!sui-p-0', 'sui-text-base', 'sui-leading-normal', 'sui-font-regular');

  return (
    <ListItem className={classes}>
      {content}
    </ListItem>
  );
};

SalientListItem.displayName = 'SalientListItem';

SalientListItem.propTypes = {
  // Additional salient points apart from productHighlights
  children: node,
  // Additional class names
  className: string,
  // A salient point featuring productHighlights
  point: string
};

export { SalientListItem };
